import { PAGE } from '@/constants/page.js'
export const getPage = (pageid) => {
  switch (pageid) {
    case '108234815144840':
    case '110981841237323':
    case '1037700739663223':
    case '101542172593323':
      return 'nestle'
    case '101802199107897':
      return 'secap'
    case '111895158162143':
      return 'hopinnhr'
    case '106004118709627':
    case '150765918293329':
      return 'gpf'
    case '110880794986721':
    case '104039299068829':
      return 'yasale-ac'
    case '108586555240680':
    case '102071912676867':
      return 'nongtungjai'
    case '103746389114044':
    case '105763258933863':
    case '109966648492321':
      return 'summithr'
    case '105432182130709':
    case '462339517184685':
      return 'cityfresh'
    case '100305558382056':
    case '103174965660875':
      return 'dtac-gaming'
    case '107879035335045':
    case '1688468514708248':
      return 'mtc'
    case '102549712095297':
    case '105387828535129':
      return 'nextcapital'
    case PAGE.TRUEIDTEST:
    case PAGE.TRUEID:
      return 'trueid'
    case PAGE.YASALE:
      return 'yasale'
    case '115414076948160':
    case '396306053873110':
      return 'thailandpostmart'
    case '1637674519806774':
      return 'Aira'
    case '105017609020919':
      return 'Airatest'
    case '104614765775640':
      return 'nt'
    default:
      return 'default'
  }
}



// WEBPACK FOOTER //
// ./src/config/customize.js